// @ts-nocheck
import * as React from "react";

const MinusCircleFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm3 11H9a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(MinusCircleFill);
